<template>
    <div>
        <Loader v-if="loading" />
        <div v-else class="container-fluid mt-45">
            <div class="row">
                <div class="col">
                    <p class="h2 mt-0 mb-1">Patient created</p>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <div class="alert alert-success h5 py-4">
                        <img style="margin-right: 4px" class="v-align-sub" src="@/assets/images/icons/green-tick.svg" width="25" alt="tick"> A new patient has been created
                    </div>
                </div>
            </div>

            <PatientDetails
                v-if="Object.keys(patientDetails).length"
                :patient="patientDetails"
                :hideEdit="Boolean(true)"
                class="mt-1" 
            />
        </div>

        <div class="fixed-bottom bg-white py-25">
            <div class="container-fluid">
                <div class="row">
                    <div class="col text-right">
                        <button @click="returnToDashboard()" class="btn btn-yellow btn-lg lg-shadow">Return to Dashboard</button>
                        <button v-show="!facilitiesAllDisabled" @click="next()" class="btn btn-success btn-lg lg-shadow ml-2">Assign a test kit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {mapGetters, mapActions} from 'vuex'
import Loader from '../../../Common/components/Loader.vue'
import PatientDetails from '../../../Common/components/PatientDetailsComponent.vue'
import CancelTestModalComponent from '@/components/modals/CancelTestModalComponent.vue'
import FulfilmentOptions from '../../../Common/enums/FulfilmentOptionsType'
import IssueMethod from '../../../Common/enums/IssueMethod'
export default {
    name: 'PatientCreated',

    components: {
        Loader,
        PatientDetails
    },

    data() {
        return {
            loading: true,
            patientDetails: {},
            CancelTestModalComponent,
            issueInPersonOverride: process.env.VUE_APP_ISSUE_IN_PERSON_OVERRIDE == 1 ? true : false,
            FulfilmentOptions,
            IssueMethod
        }
    },

    async mounted() {
        if(!this.patientId) return this.$router.push({name: 'Dashboard'})

        try {
            let response = await axios.get(`${process.env.VUE_APP_AXIOS_PATIENT_BASE_URL}/api/v1/patients/${this.organisationId}/${this.patientId}`)

            this.patientDetails = response.data
        }
        catch {
            this.setNotification({
                type: 'error',
                title: 'Error',
                message: 'Something went wrong while fetching the patient details'
            })
        }
        finally {
            this.loading = false
        }
    },

    computed: {
        ...mapGetters({
            organisationId: 'UserStore/GetUserOrganisationId',
            patientId: 'TestStore/GetPatientId',
            facilitiesAllDisabled: 'FacilityStore/GetAllFacilitiesDisabled',
            myOrganisationSettings: 'OrganisationStore/GetMyOrganisationSettings'
        })
    },

    methods: {
        ...mapActions({
            clearSearchStore: 'SearchStore/ClearSearchStore',
            setNotification: 'NotificationStore/SetNotification',
            setShippingAddressTypeInTestStoreAction: 'TestStore/SetShippingAddressType',
            setDeliveryMethodInTestStoreAction: 'TestStore/SetDeliveryMethod'
        }),

        returnToDashboard() {
            this.clearSearchStore()

            return this.$router.push({name: 'Dashboard'})
        },

        async next() {
            if(this.myOrganisationSettings.fulfilmentOptions == this.FulfilmentOptions.POST) {
                await this.setDeliveryMethodInTestStoreAction(this.IssueMethod.POST)
                await this.setShippingAddressTypeInTestStoreAction(0)
                return this.$router.push({name: 'TestDetails'})
            }

            if(this.myOrganisationSettings.fulfilmentOptions == this.FulfilmentOptions.IN_PERSON) {
                await this.setDeliveryMethodInTestStoreAction(this.IssueMethod.IN_PERSON)
                await this.setShippingAddressTypeInTestStoreAction(0)
                return this.$router.push({name: 'TestDetails'})
            }
            
            if(this.myOrganisationSettings.fulfilmentOptions == this.FulfilmentOptions.ALL) {
                return this.$router.push({name: 'DeliveryMethod'})
            }

            if(this.issueInPersonOverride) {
                await this.setDeliveryMethodInTestStoreAction(this.IssueMethod.IN_PERSON)
                await this.setShippingAddressTypeInTestStoreAction(0)
                return this.$router.push({name: 'TestDetails'})
            }

            await this.setDeliveryMethodInTestStoreAction(this.IssueMethod.POST)
            await this.setShippingAddressTypeInTestStoreAction(0)
            return this.$router.push({name: 'TestDetails'})
        }
    }
}
</script>